import { isEmpty, isNil } from 'lodash';

import { sylvanus } from '~/services/serviceInstances';
import { GenClauseResult } from '~/types/GenAi';

interface GenClauseRequest {
  instructions: string;
  static?: boolean;
  text?: string;
}

export const getGenClauseResult = async (
  request: GenClauseRequest,
): Promise<GenClauseResult> => {
  if (isNil(request.text) || isEmpty(request.text)) {
    return await sylvanus.post('/clause/generate', request);
  } else {
    return await sylvanus.post('/clause/redline', request);
  }
};

export const getGenClauseResults = async (
  request: GenClauseRequest,
): Promise<GenClauseResult[]> => {
  const requests = Array.from({ length: 3 }).map((_, i) =>
    getGenClauseResult({
      ...request,
      static: i === 0, // first request is always static
    }),
  );

  return Promise.all(requests) as unknown as Promise<GenClauseResult[]>;
};
